/**
 * Configurações de status e seus estilos visuais
 */

import { XCircleIcon as XCircle, AlertTriangleIcon as AlertTriangle, CheckCircle2Icon as CheckCircle2 } from '../../icons';

export const statusConfig = {
  error: {
    bgColor: 'bg-red-500/25',
    borderColor: 'border-red-400',
    iconColor: 'text-red-400',
    icon: XCircle,
    hoverBg: 'hover:bg-red-500/35',
    dimTextColor: 'text-red-300',
  },
  warning: {
    bgColor: 'bg-orange-500/15',
    borderColor: 'border-orange-400',
    iconColor: 'text-orange-400',
    icon: AlertTriangle,
    hoverBg: 'hover:bg-orange-500/25',
    dimTextColor: 'text-orange-300',
  },
  success: {
    bgColor: 'bg-emerald-500/10',
    borderColor: 'border-emerald-500',
    iconColor: 'text-emerald-500',
    icon: CheckCircle2,
    hoverBg: 'hover:bg-emerald-500/15',
    dimTextColor: 'text-gray-300',
  }
}; 